import { createInterpolationCallback, createInterpolator } from './createInterpolator';
/**
 * Create TAnimation from object
 *
 * @category Animation
 * @param simpleAnimation
 * @returns
 */
export function createAnimation(simpleAnimation) {
    const interpolate = createInterpolationCallback(simpleAnimation);
    if (typeof interpolate === 'undefined')
        return undefined;
    const delay = simpleAnimation.delay || 0;
    const afterDelay = simpleAnimation.afterDelay || 0;
    const direction = simpleAnimation.direction || 'normal';
    const duration = simpleAnimation.duration || 1000;
    const totalDuration = direction === 'normal'
        ? duration + delay
        : direction === 'reverse'
            ? duration + delay
            : duration * 2 + delay + afterDelay;
    const loop = typeof simpleAnimation.loop === 'number' ? simpleAnimation.loop : !!simpleAnimation.loop;
    const bindedValues = {
        delay,
        afterDelay,
        direction,
        duration,
        totalDuration,
        loop,
    };
    const animationFunction = createInterpolator(simpleAnimation.interpolator);
    const animation = {
        loop: 0,
        offset: 0,
        loopDuration: totalDuration,
        direction: direction === 'alternate' ? 'normal' : direction,
        started: false,
        ended: false,
        value: undefined,
    };
    animation.update = createUpdate(animation, bindedValues, animationFunction, interpolate);
    return animation;
}
/**
 *
 * @internal
 * @param animation
 * @param bindedValues
 * @param animationFunction
 * @param interpolate
 * @returns
 */
function createUpdate(animation, bindedValues, animationFunction, interpolate) {
    const { loop, totalDuration, delay, afterDelay, direction, duration } = bindedValues;
    return (time) => {
        // Check animation is ended
        if ((typeof loop === 'number' && time >= totalDuration * loop) ||
            (loop === false && time >= bindedValues.totalDuration)) {
            animation.started = false;
            animation.ended = true;
            animation.offset = animationFunction(direction === 'normal' ? duration : 0, duration);
            animation.value = interpolate(animation.offset);
            return;
        }
        animation.loop = Math.ceil(time / totalDuration);
        time %= totalDuration;
        if ((time -= delay) <= 0) {
            animation.started = false;
            animation.offset = animationFunction(0, duration);
            animation.value = interpolate(animation.offset);
            return;
        }
        animation.started = true;
        if (direction === 'alternate') {
            if (time <= duration) {
                animation.direction = 'normal';
                animation.offset = animationFunction(time, duration);
            }
            else {
                animation.direction = 'reverse';
                time -= duration;
                // wait afterDelay
                if ((time -= afterDelay) >= 0) {
                    animation.offset = 1 - animationFunction(time >= duration ? duration : time, duration);
                }
                else {
                    animation.offset = 1;
                }
            }
        }
        else {
            const animationValue = animationFunction(time >= duration ? duration : time, duration);
            animation.offset = direction === 'normal' ? animationValue : 1 - animationValue;
        }
        animation.value = interpolate(animation.offset);
    };
}
//# sourceMappingURL=createAnimation.js.map